import React, { useState } from "react";
import { Box } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import { useDashboardTheme } from "../../../context/DashboardThemeContext";
import ThemeColors from "./Configurations/ThemeSettings";
import PermissionsConfig from "./Configurations/PermissionsSettings";

export default function Configurations() {
  const { dashboardTheme } = useDashboardTheme();
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [searchParams] = useSearchParams();

  const section = searchParams.get("section") || "appearance";

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: dashboardTheme.dashboard_background,
        display: "flex",
        color: dashboardTheme.text_color,
        overflowX: "hidden",
      }}
    >
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <TopBar
          sidebarOpen={sidebarOpen}
          onToggleSidebar={() => setSidebarOpen((prev) => !prev)}
        />

        <Box
          component="main"
          sx={{
            flex: 1,
            p: { xs: 2, md: 3 },
          }}
        >
          {section === "access" ? <PermissionsConfig /> : <ThemeColors />}
        </Box>
      </Box>
    </Box>
  );
}